FilterBubbles.getText = function (key, value) {
    var inputs = this.get(key, value),
        input = inputs[0];
    if (!input) {
        return "";
    }

    switch (input.tagName.toLowerCase()) {
        case "select":
            return $(input)
                .find("option")
                .filter(function () {
                    return $(this).val() == value;
                })
                .eq(0)
                .text();

        case "input":
            var $label = $(input).parents(".form-group").find("label");
            if (!$label.size()) {
                $label = $(input).parents("label");
            }
            if (!$label.size()) {
                $label = $(input).next("label");
            }

            return $label.clone().find(".filter__content__count").remove().end().html();
    }
};

function updateFilterBubbles() {
    const $bubblesWrappers = $(".js-filter-bubbles-wrapper");

    for (const bubblesWrapper of $bubblesWrappers) {
        const $bubblesWrapper = $(bubblesWrapper);
        const $bubblesItems = $bubblesWrapper.find(".js-filter-bubbles-item");
        const $bubblesReset = $bubblesWrapper.find(".js-filter-bubbles-reset");
        const $listingCount = $(".js-listing-count-toggle");

        $bubblesWrapper.data("count", $bubblesItems.length);

        if ($bubblesItems.length < 1) {
            $bubblesReset.remove();
            $bubblesWrapper.removeClass("is-visible");
            $listingCount.addClass("is-visible");
        } else {
            $bubblesWrapper.addClass("is-visible");
            $listingCount.removeClass("is-visible");
        }
    }
}

function renderFilterBubbles() {
    updateFilterBubbles();

    rEvent.on("FilterBubbles.afterRefresh", function () {
        updateFilterBubbles();
    });

    rEvent.on("FilterBubbles.returnedRefresh", function () {
        updateFilterBubbles();
    });

    $("body").on("change", '.c-aside-filter [type="checkbox"]', function () {
        updateFilterBubbles();
    });

    // filter bubbles reset hide
    $("body").on("click", ".js-filter-bubbles-item", function () {
        const filterKey = this.dataset.filterKey;
        const filterValue = this.dataset.filterValue;

        $(
            `.js-filter-bubbles-item[data-filter-key="${filterKey}"][data-filter-value="${filterValue}"]`
        ).remove();

        requestAnimationFrame(() => {
            updateFilterBubbles();
        });
    });

    $("body").on("click", ".js-filter-bubbles-reset", function () {
        $(".c-filter").find(".js-reset").click();
    });

    rEvent.on("Filter.reset", function () {
        updateFilterBubbles();
    });
}

FilterBubbles.create = function (filterSelector, options) {
    this.template = options.template;
    this.clearFilterTemplate = options.clearFilterTemplate;

    this.initialize();

    rEvent.dispatch("FilterBubbles.created");

    return this;
};

FilterBubbles.add = function (data) {
    if (!data.content) {
        return;
    }

    if ($(this.container).find(".js-filter-bubbles-reset").length == 0) {
        $(this.container).prepend(
            _.template(this.clearFilterTemplate)({
                _class: "",
            })
        );
    }

    $(this.container).append(_.template(this.template)(data));
    $('[data-element="filterBubbles"]').attr("data-count", $(this.holder).size());

    rEvent.dispatch("FilterBubbles.added");
};

FilterBubbles.get = function (key, value) {
    return Filter.filterInputs.filter(function () {
        if (this.name == "filter[rating_avg]" && ["0_100", ""].includes(this.value)) {
            return false;
        }

        switch (this.tagName.toLowerCase()) {
            case "select":
                return this.name == key;

            case "input":
                return this.name == key && this.value == value;
        }
    });
};

$(function () {
    renderFilterBubbles();
});
